// removed by extract-text-webpack-plugin
module.exports = {"person":"_23U7XJsKpLXXSI-NvKE-Uh","unused":"_2A8m-k1231IHpMPWP7xx7q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Song/Person.scss
// module id = 826
// module chunks = 0